export const civs = {
  abb: {
    label: "Abbassid",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/ab.png",
    color: "#5D6063",
  },
  ayy: {
    label: "Ayyubids",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/ay.png",
    color: "#C5B537",
  },
  byz: {
    label: "Byzantines",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/by.png",
    color: "#8038BE",
  },
  chi: {
    label: "Chinese",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/ch.png",
    color: "#E15034",
  },
  del: {
    label: "Delhi",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/de.png",
    color: "#00AF63",
  },
  eng: {
    label: "English",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/en.png",
    color: "#C3D1DF",
  },
  fre: {
    label: "French",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/fr.png",
    color: "#0087E7",
  },
  hre: {
    label: "Holy Roman Empire",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/hr.png",
    color: "#FFCB2F",
  },
  jap: {
    label: "Japanese",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/ja.png",
    color: "#B8B594",
  },
  jea: {
    label: "Jeanne d'Arc",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/je.png",
    color: "#FFD65C",
  },
  mal: {
    label: "Malians",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/ma.png",
    color: "#D61D60",
  },
  mon: {
    label: "Mongols",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/mo.png",
    color: "#16A8FF",
  },
  ord: {
    label: "Order of the Dragon",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/od.png",
    color: "#E0D678",
  },
  ott: {
    label: "Ottomans",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/ot.png",
    color: "#0F6F3E",
  },
  rus: {
    label: "Rus",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/ru.png",
    color: "#F74C43",
  },
  zhu: {
    label: "Zhu Xi's Legacy",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/zx.png",
    color: "#00A6A7",
  },
  knt: {
    label: "Knights Templar",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/kt.png",
    color: "#140705",
  },
  hol: {
    label: "House of Lancaster",
    flag: "https://raw.githubusercontent.com/aoe4world/explorer/main/assets/flags/hl.png",
    color: "#02197E",
  },
};
